import { useMemo } from "react";
import { Outlet } from "react-router-dom";
import {
  RegistrationProvider,
  type RegistrationConfig,
} from "@fmc-digital/profile";
import { config } from "@/config";
import { buildImageUrl } from "@/utils/imageUrl";
import {
  trackRegistrationEvent,
  trackRegistrationValuePropEvent,
  trackDownloadAppEvent,
} from "@/utils/analytics.utils";

function buildRegistrationConfig(): RegistrationConfig {
  return {
    apiBaseUrl: config.env("baseUrl") || config.getCachedConfig()?.api?.baseUrl || "",
    apiBaseUrlV2:
      config.getCachedConfig()?.api?.baseUrlV2 ||
      config.getCachedConfig()?.api?.baseUrl ||
      config.env("baseUrl"),
    qualtricsUrl: config.getCachedConfig()?.qualtricsUrl,
    qualtricsAPIKey: config.getCachedConfig()?.qualtricsAPIKey,
    registrationNpsSurveyId: config.getCachedConfig()?.registrationNpsSurveyId,
    cdnRootUrl: config.env("cdnRootUrl"),
    mobileAppDownloadUrl: config.env("mobileAppDownloadUrl"),
    baseUrl: config.env("baseUrl"),
  };
}

/**
 * Wraps all /register/* routes with registration config and analytics injection.
 */
export function RegistrationRoutesLayout() {
  const registrationConfig = useMemo(() => buildRegistrationConfig(), []);

  const setApiBaseUrl = (url: string) => {
    if (globalThis.window !== undefined) {
      const w = globalThis.window as Window & { __authShellConfig?: { apiBaseUrl?: string } };
      if (w.__authShellConfig) {
        w.__authShellConfig.apiBaseUrl = url;
      }
    }
  };

  const getApiBaseUrl = () => {
    if (globalThis.window !== undefined) {
      const w = globalThis.window as Window & { __authShellConfig?: { apiBaseUrl?: string } };
      return w.__authShellConfig?.apiBaseUrl;
    }
    return undefined;
  };

  return (
    <RegistrationProvider
      config={registrationConfig}
      trackRegistrationEvent={trackRegistrationEvent}
      trackRegistrationValuePropEvent={trackRegistrationValuePropEvent}
      trackDownloadAppEvent={trackDownloadAppEvent}
      buildImageUrl={buildImageUrl}
      setApiBaseUrl={setApiBaseUrl}
      getApiBaseUrl={getApiBaseUrl}
    >
      <Outlet />
    </RegistrationProvider>
  );
}
